import React, { useState } from 'react';
import { SyncIndex } from './sync-history/SyncIndex';
import { SyncRunDetail } from './sync-history/SyncRunDetail';
import { RecordSheet } from './sync-history/RecordSheet';
import { SYNC_RUNS, SyncRecord } from './sync-history/types';
export function SyncHistoryView() {
  const [selectedRunId, setSelectedRunId] = useState<string | null>(null);
  const [selectedRecord, setSelectedRecord] = useState<SyncRecord | null>(null);
  const run = selectedRunId ? SYNC_RUNS.find(r => r.id === selectedRunId) ?? null : null;
  return <div className="min-h-[calc(100vh-56px)] pt-16 pb-32 px-6 text-[#e8e4df] selection:bg-[#4a9a9a]/30" data-id="element-2141">
      <div className="max-w-[900px] mx-auto w-full" data-id="element-2142">
        {run ? <SyncRunDetail run={run} onBack={() => setSelectedRunId(null)} onSelectRecord={setSelectedRecord} data-id="element-2143" /> : <SyncIndex onSelectRun={setSelectedRunId} data-id="element-2144" />}
      </div>
      <RecordSheet record={selectedRecord} onClose={() => setSelectedRecord(null)} data-id="element-2145" />
    </div>;
}